<div class="p-g-12">
    <p-toolbar>
        <div class="p-toolbar-group-left p-toolbar-tecfolk-fix">
            <button routerLink="/requests-management" pButton type="button" [label]='setLabel("goBackBtnLabel")'
                icon="pi pi-arrow-left"></button>
        </div>
    </p-toolbar>
</div>
<div class="p-g-12 fee-submission-requestDetail">
    <form class="form" #requestorForm="ngForm">
        <div class="p-g-12">
            <div class="p-g-12">
                <h3 class="title first">{{setLabel("memberDetailsLabel")}}</h3>
                <div *ngIf="requestor.requestType === 'Registration'" class="member-img"
                    style="width: 200px; height: 200px">
                    <img width="100%" height="100%" [src]="
                            requestor.profile == null
                                ? 'assets/layout/images/avatarBoyImage.png'
                                : config.Server + config.memberImagePath +requestor.profile
                        " style="border-radius: 100%" />
                </div>

                <div *ngIf="requestor.requestType === 'FeeSubmission'" class="member-img"
                    style="width: 200px; height: 200px">
                    <img width="100%" height="100%" [src]=" member.profile
                    ? config.Server + config.memberImagePath + 'thumbs/' + member.profile
                    : member.gender &&
                      member.gender == 'F'
                    ? 'assets/layout/images/avatarGirlImage.png'
                    : 'assets/layout/images/avatarBoyImage.png'" style="border-radius: 100%" />

                </div>
                <div *ngIf="requestor.requestType === 'OnlineRegistrationFee'" class="member-img"
                    style="width: 200px; height: 200px">
                    <img width="100%" height="100%" [src]=" member.profile
                    ? config.Server + config.memberImagePath + 'thumbs/' + member.profile
                    : member.gender &&
                      member.gender == 'F'
                    ? 'assets/layout/images/avatarGirlImage.png'
                    : 'assets/layout/images/avatarBoyImage.png'" style="border-radius: 100%" />

                </div>
            </div>
        </div>
        <div class="displayFlextonDirRTL detail-main p-g-12">
            <div class="p-g-12 p-md-6">
                <div class="p-g-12">
                    <h3 class="first">{{setLabel("nameLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                        <input class="input" autocomplete="off" #memberName pattern="[A-Za-z ]+" [ngClass]="
                                memberName.invalid &&
                                (memberName.dirty || memberName.touched)
                                    ? 'errorInput'
                                    : ''
                            " type="text" pInputText [placeholder]='setLabel("namePlaceholderLabel")' name="memberName"
                            required [(ngModel)]="member.name" style="width: 60%" />
                    </div>
                    <div *ngIf="
                            memberName.invalid &&
                            (memberName.dirty || memberName.touched)
                        ">
                        <div *ngIf="memberName.errors.required" class="errorShow">
                            {{setLabel("nameIsRequiredLabel")}}
                        </div>
                        <div *ngIf="memberName.errors.pattern" class="errorShow">
                            {{setLabel("charactersAllowedLabel")}}
                        </div>
                    </div>
                </div>
                <div class="p-g-12">
                    <h3 class="first">{{setLabel("emailLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                        <input class="input" type="email" autocomplete="off" pInputText
                            [placeholder]='setLabel("emailPlaceholderLabel")' name="email" #email
                            [(ngModel)]="member.email" style="width: 60%" />
                    </div>
                </div>
                <div class="p-g-12">
                    <app-phone-input
                    [placeholder]='setLabel("mobilePlaceholderLabel")'
                    [(phoneNumber)]="member.contactDetail.contact"
                    [initialCountry]="'PK'"
                    (validNumber)="formattedNumber = $event"
                    (formattedForSaving)="member.contactDetail.contact = $event"
                    style="max-width: 600px; margin: auto; align-items: center;">
                </app-phone-input>
                  </div>
            </div>
            <div class="p-g-12 p-md-6">
                <div class="p-g-12">
                    <h3 class="first">{{setLabel("addressLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-location-arrow" aria-hidden="true"></i></span>
                        <input class="input" type="text" pInputText [placeholder]='setLabel("streetPlaceholderLabel")'
                            name="street" autocomplete="off" [ngModel]="member.contactDetail.address?.street"
                            style="width: 60%" />
                    </div>
                </div>
                <div class="p-g-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                        <input class="input" type="text" pInputText [placeholder]='setLabel("cityPlaceholderLabel")'
                            name="city" autocomplete="off" [ngModel]="member.contactDetail.address?.city"
                            style="width: 60%" />
                    </div>
                </div>
                <div class="p-g-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                        <input class="input" type="text" pInputText [placeholder]='setLabel("countryPlaceholderLabel")'
                            name="country" autocomplete="off" [ngModel]="member.contactDetail.address?.country"
                            style="width: 60%" />
                    </div>
                </div>
                <div class="p-g-12">
                    <div class="p-g">
                        <div class="p-g-12">
                            <h3 class="first">{{setLabel("genderLabel")}}</h3>
                            <div class="gender-option">
                                <div class="p-md-6">
                                    <p-radioButton name="gender" value="M" [label]='setLabel("MaleLabel")'
                                        [(ngModel)]="requestor.gender" inputId="opt1">
                                    </p-radioButton>
                                </div>
                                <div class="p-g-6">
                                    <p-radioButton name="gender" value="F" [label]='setLabel("FemaleLabel")'
                                        [(ngModel)]="requestor.gender" inputId="opt2">
                                    </p-radioButton>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr />
        <div class="textalignRightonDirRTL p-g-12">
            <div class="textalignRightonDirRTL p-g-12 p-md-6" style="text-align: left">
                <h3 class="title first">{{setLabel("feeDetailsLabel")}}</h3>
                <div class="car-detail">
                    <img class="fee-img" style="max-width:400px"
                        [src]="config.Server + config.feereceiptImagePath + requestor.feeSubmissionDetail?.feeReceiptImageUrl" />
                </div>
                <div class="p-g-12">
                    <h3 class="first">{{setLabel("requestTypeLabel")}}</h3>
                    <div class="p-inputgroup align-items-center">
                        <span class="p-inputgroup-addon"><i class="fa fa-list" aria-hidden="true"></i></span>
                        {{ requestor.requestType }}
                    </div>
                </div>
            </div>

            <div class="textalignRightonDirRTL p-g-12 p-md-6" style="text-align: left">
                <div class="p-g-12">
                    <h3 class="first">{{setLabel("monthlyFeeReceivedLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input class="input" type="number" pInputText
                            [placeholder]='setLabel("feeReceivedPlaceholderLabel")' name="pay" autocomplete="off"
                            [(ngModel)]="requestor.feeSubmissionDetail.pay" style="width: 60%" #pay="ngModel" required
                            readonly />
                    </div>

                    <div *ngIf="pay.invalid && (pay.dirty || pay.touched)">
                        <div *ngIf="pay.errors.required" class="errorShow">
                            {{setLabel("feeReceivedIsRequiredLabel")}}
                        </div>
                    </div>
                </div>

                <div class="p-g-12" *ngIf="requestor.requestType === 'OnlineRegistrationFee'">
                    <h3 class="first">{{setLabel("registrationFeeReceivedLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input class="input" type="number" pInputText
                            [placeholder]='setLabel("feeReceivedPlaceholderLabel")' name="payReg" autocomplete="off"
                            [(ngModel)]="requestor.feeSubmissionDetail.payReg" style="width: 60%" #pay="ngModel"
                            required readonly />
                    </div>

                    <div *ngIf="pay.invalid && (pay.dirty || pay.touched)">
                        <div *ngIf="payReg.errors.required" class="errorShow">
                            {{setLabel("feeReceivedIsRequiredLabel")}}
                        </div>
                    </div>
                </div>
                <div class="p-g-12"
                    *ngIf="requestor.requestType === 'OnlineRegistrationFee' && requestor.feeSubmissionDetail.monthlyDiscount ">
                    <h3 class="first">{{setLabel("discountOnMonthlyFeeLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input class="input" type="number" pInputText
                            [placeholder]='setLabel("discountPlaceholderLabel")' name="monthlyDiscount"
                            autocomplete="off" [(ngModel)]="requestor.feeSubmissionDetail.monthlyDiscount"
                            style="width: 60%" #pay="ngModel" readonly />
                    </div>
                </div>
                <div class="p-g-12"
                    *ngIf="requestor.requestType === 'OnlineRegistrationFee' && requestor.feeSubmissionDetail.registrationDiscount ">
                    <h3 class="first">{{setLabel("discountOnRegistrationFeeLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input class="input" type="number" pInputText
                            [placeholder]='setLabel("discountPlaceholderLabel")' name="registrationDiscount"
                            autocomplete="off" [(ngModel)]="requestor.feeSubmissionDetail.registrationDiscount"
                            style="width: 60%" #pay="ngModel" readonly />
                    </div>
                </div>
                <div class="p-g-12"
                    *ngIf=" (requestor.feeSubmissionDetail.taxType == 'WITH_TAX' || requestor.feeSubmissionDetail.taxType == 'INCLUDING_TAX') ">
                    <h3 class="first">{{setLabel("taxOnMonthlyFeeFeeLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input class="input" type="number" pInputText [placeholder]='setLabel("taxPlaceholderLabel")'
                            name="monthlyTax" autocomplete="off" [(ngModel)]="requestor.feeSubmissionDetail.monthlyTax"
                            style="width: 60%" #pay="ngModel" readonly />
                    </div>
                    <div *ngIf="requestor.feeSubmissionDetail.taxType == 'INCLUDING_TAX'"
                        style="font-style: italic; color: blue;">{{setLabel("taxIncludedFeeLabel")}} </div>

                </div>
                <div class="p-g-12"
                    *ngIf="requestor.requestType === 'OnlineRegistrationFee' && (requestor.feeSubmissionDetail.taxType == 'WITH_TAX' || requestor.feeSubmissionDetail.taxType == 'INCLUDING_TAX') ">
                    <h3 class="first">{{setLabel("taxOnRegistrationFeeFeeLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input class="input" type="number" pInputText [placeholder]='setLabel("taxPlaceholderLabel")'
                            name="registrationTax" autocomplete="off"
                            [(ngModel)]="requestor.feeSubmissionDetail.registrationTax" style="width: 60%"
                            #pay="ngModel" readonly />
                    </div>
                    <div *ngIf="requestor.feeSubmissionDetail.taxType == 'INCLUDING_TAX'"
                        style="font-style: italic; color: blue;">{{setLabel("taxIncludedFeeLabel")}}</div>
                </div>
                    <div class="p-g-12" *ngIf="requestor.requestType === 'OnlineRegistrationFee'">
                        <h3 class="first">{{setLabel("totalFeeReceivedLabel")}}</h3>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                            <input class="input" type="number" pInputText [placeholder]='setLabel("totalFeePlaceholderLabel")'
                                name="totalFeeReceived" autocomplete="off" [(ngModel)]="requestor.feeSubmissionDetail.totalFeeReceived"
                                style="width: 60%" #pay="ngModel" readonly />
                        </div>
                    </div>
                <div class="p-g-12" *ngIf="requestor.requestType === 'FeeSubmission'">
                    <h3 class="first">{{setLabel("totalFeeReceivedLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input class="input" type="number" pInputText
                            [placeholder]='setLabel("totalFeePlaceholderLabel")' name="totalFeeReceived"
                            autocomplete="off" [(ngModel)]="requestor.feeSubmissionDetail.totalFeeReceived"
                            style="width: 60%" #pay="ngModel" readonly />
                    </div>
                </div>
                <!-- <div class="p-g-12">
                    <h3 class="first">Transaction Number</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input class="input" type="text" pInputText placeholder="Transaction Number"
                            name="transactionNumber" autocomplete="off" ngModel style="width: 60%"
                            #transactionNumber="ngModel" />
                    </div>
                </div> -->
                <div class="p-g-12">
                    <h3 class="first">{{setLabel("paymentBankLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-bank" aria-hidden="true"></i></span>
                        <p-dropdown class="p-g-8" [options]="paymentModes"
                            (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
                    </div>
                </div>
                <div class="p-g-12">
                    <h3 class="first">{{setLabel("requestStatusLabel")}}</h3>
                    <div class="p-inputgroup align-items-center">
                        <span class="p-inputgroup-addon"><i class="fa fa-question-circle" aria-hidden="true"></i></span>
                        {{ requestor.requestStatus }}
                    </div>
                </div>
            </div>
        </div>
        <div class="p-g-12">
            <!-- <div class="p-g-12 p-md-6" style="text-align: left">

            </div> -->
            <div class="btn-main p-g-12 p-md-6 p-lg-12" style="text-align: center">
                <button pButton type="button" style="border-radius: 5px !important;
                background-color: #3f51b5;" class="p-button-primary submitButton p-widget p-state-default p-corner-all"
                    *ngIf="requestor?.requestStatus === RequestStatus.Pending" (click)="rejectRequest()">
                    <span class="p-button-text p-c">
                        <i class="fa fa-times" aria-hidden="true"></i>
                        &nbsp;{{setLabel("rejectBtnLabel")}}
                    </span>
                </button>
                &nbsp;
                <button pButton type="button" style="border-radius: 5px !important"
                    class="p-button-success submitButton p-widget p-state-default p-corner-all"
                    (click)="approveRequest(requestorForm)" [disabled]="!requestorForm.valid"
                    *ngIf="requestor?.requestStatus === RequestStatus.Pending">
                    <span class="p-button-text p-c">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        &nbsp;{{setLabel("approveBtnLabel")}}
                    </span>
                </button>
            </div>
        </div>
    </form>
</div>